var map = {
	"./multiplier_0_en.png": "381b",
	"./multiplier_0_th.png": "3a0a",
	"./multiplier_0_zh.png": "1031",
	"./multiplier_3_en.png": "9219",
	"./multiplier_3_th.png": "29c5",
	"./multiplier_3_zh.png": "f080",
	"./multiplier_5_en.png": "dd8d0",
	"./multiplier_5_th.png": "9036",
	"./multiplier_5_zh.png": "3763",
	"./multiplier_8_en.png": "d90e",
	"./multiplier_8_th.png": "5cb2",
	"./multiplier_8_zh.png": "da1c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9c19";